import React, { useState, useEffect } from "react";
import { Button, message } from "antd";
import { ClockCircleOutlined } from "@ant-design/icons";
import Service from "../../service";
import { useSelector } from "react-redux";
import "./PunchButton.css";

const PunchButton = () => {
  const authUser = useSelector((state) => state.auth.authUser);
  const [nextAction, setNextAction] = useState("IN"); // What the next punch should be
  const [lastPunchTime, setLastPunchTime] = useState(null);
  const [loading, setLoading] = useState(false);
  const [checkingStatus, setCheckingStatus] = useState(true);

  // Get current punch status on component mount
  useEffect(() => {
    if (authUser?._id) {
      getPunchStatus();
    }
  }, [authUser?._id]);

  const getPunchStatus = async () => {
    try {
      setCheckingStatus(true);
      const response = await Service.makeAPICall({
        methodName: Service.postMethod,
        api_url: Service.punchStatus,
        body: {
          employee_id: authUser._id,
        },
      });

      if (response.data && response.data.status === 200) {
        // Use nextAction to determine what button should show
        setNextAction(response.data.data.nextAction || "IN");
        setLastPunchTime(response.data.data.lastPunchTime);
      }
    } catch (error) {
      console.error("Error fetching punch status:", error);
    } finally {
      setCheckingStatus(false);
    }
  };

  const handlePunch = async () => {
    if (!authUser?._id) {
      message.error("User not authenticated");
      return;
    }

    try {
      setLoading(true);
      const response = await Service.makeAPICall({
        methodName: Service.postMethod,
        api_url: Service.punchInOut,
        body: {
          employee_id: authUser._id,
        },
      });

      if (response.data && response.data.status === 200) {
        const newDirection = response.data.data.direction;
        setLastPunchTime(response.data.data.time);
        message.success(response.data.message || `Punch ${newDirection} recorded successfully`);
        
        // Update nextAction based on what was just recorded
        // If we just punched IN, next should be OUT, and vice versa
        setNextAction(newDirection === "IN" ? "OUT" : "IN");
        
        // Emit custom event to trigger refresh in other components
        window.dispatchEvent(new CustomEvent('punchRecorded', {
          detail: {
            direction: newDirection,
            time: response.data.data.time,
            timestamp: response.data.data.timestamp
          }
        }));
        
        // Refresh status after a short delay to ensure consistency
        setTimeout(() => {
          getPunchStatus();
        }, 1000);
      } else {
        message.error(response.data?.message || "Failed to record punch");
      }
    } catch (error) {
      console.error("Error recording punch:", error);
      message.error(error.response?.data?.message || "Failed to record punch. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const getButtonText = () => {
    if (checkingStatus) {
      return "Loading...";
    }
    return nextAction === "OUT" ? "Punch Out" : "Punch In";
  };

  const getButtonType = () => {
    return nextAction === "OUT" ? "default" : "primary";
  };

  return (
    <Button
      type={getButtonType()}
      icon={<ClockCircleOutlined />}
      onClick={handlePunch}
      loading={loading || checkingStatus}
      className="punch-button ant-btn-primary add-btn"
      title={lastPunchTime ? `Last punch: ${lastPunchTime}` : "Record your attendance"}
    >
      {getButtonText()}
    
    </Button>
  );
};

export default PunchButton;

